import React from "react";
import { Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import {
  AUTHENTICATED_ENTRY,
  AUTHENTICATED_INACTIVE_COMPANY_ENTRY,
} from "configs/AppConfig";
import {
  inactiveCompanyRoutes,
  protectedRoutes,
  publicRoutes,
} from "configs/RoutesConfig";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";
import AppRoute from "./AppRoute";
import { useSelector } from "react-redux";

const Routes = () => {
  const { token, user } = useSelector((state) => state.auth);
  const isCompanyActive =
    user?.current_company?.is_active || Boolean(user?.is_sunday_super_admin);

  const availableProtectedRoutes = isCompanyActive
    ? protectedRoutes
    : inactiveCompanyRoutes;

  return (
    <RouterRoutes>
      <Route path="/" element={<ProtectedRoute />}>
        <Route
          path="/"
          element={
            <Navigate
              replace
              to={
                isCompanyActive
                  ? AUTHENTICATED_ENTRY
                  : AUTHENTICATED_INACTIVE_COMPANY_ENTRY
              }
            />
          }
        />
        {!!token &&
          availableProtectedRoutes.map((route, index) => {
            return (
              <Route
                key={route.key + index}
                path={route.path}
                element={
                  <AppRoute
                    routeKey={route.key}
                    component={route.component}
                    {...route.meta}
                  />
                }
              />
            );
          })}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
      <Route path="/" element={<PublicRoute />}>
        {!token &&
          publicRoutes.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={
                <AppRoute
                  routeKey={route.key}
                  component={route.component}
                  {...route.meta}
                />
              }
            />
          ))}
      </Route>
    </RouterRoutes>
  );
};

export default Routes;
